
import { IEngagementHandler, IEngagementSingleSchema } from '@ms/odsp-utilities/lib/logging/engagement/Engagement';
import ISpPageContext from '../../../interfaces/ISpPageContext';
import Guid from '@ms/odsp-utilities/lib/guid/Guid';

export interface IPageContextEngagementHandlerDependencies {
    pageContext: ISpPageContext;
}

export default class PageContextEngagementHandler implements IEngagementHandler {
    private _pageContext: ISpPageContext;

    constructor(params: {} = {}, dependencies: IPageContextEngagementHandlerDependencies) {
        this._pageContext = dependencies.pageContext;
    }

    public getEngagementData(): Partial<IEngagementSingleSchema> {
        const pageContext = this._pageContext;

        const extraData: IEngagementSingleSchema['extraData'] = {};

        const engagementData: Partial<IEngagementSingleSchema> = {
            siteId: Guid.normalizeLower(pageContext.siteId),
            webId: Guid.normalizeLower(pageContext.webId),
            webTemplateId: pageContext.webTemplate,
            extraData: extraData
        };

        if (pageContext.groupId) {
            engagementData.groupId = Guid.normalizeLower(pageContext.groupId);
        }

        if (pageContext.listId) {
            engagementData.listId = Guid.normalizeLower(pageContext.listId);
        }

        if (pageContext.listBaseTemplate > -1) {
            engagementData.listTemplateId = `${pageContext.listBaseTemplate}`;
        }

        if (pageContext.CorrelationId) {
            extraData.CorrelationId = pageContext.CorrelationId;
        }

        let accountRelation: string;

        if (pageContext.isAnonymousGuestUser) {
            accountRelation = 'anonymousGuest';
        } else if (pageContext.isEmailAuthenticationGuestUser) {
            accountRelation = 'autheticatedGuest';
        } else if (pageContext.isExternalGuestUser) {
            accountRelation = 'externalGuest';
        } else {
            accountRelation = 'authenticated';
        }

        extraData.accountRelation = accountRelation;

        return engagementData;
    }
}
